import styled from "styled-components";

export const DBDriveStatusBox = styled.div`
  display: grid;
  width: 100%;
  height: 100%;
  padding: 20px;
  background: ${(props) => props.theme.colors.primary5};
  border-radius: 6px;
  grid-template-rows: 28px auto;
  gap: 16px;
`;

export const DriveTitle = styled.div`
  width: 100%;
  height: 28px;
  color: ${(props) => props.theme.colors.black80};
  font-size: 1.6rem;
  font-weight: 600;
`;

export const DriveChartBox = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: calc(60% - 5px) calc(40% - 5px);
  gap: 10px;
`;

export const DriveStatusList = styled.ul`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 6px;
`;
